module.exports = __webpack_public_path__ + "media/images/icons/flags/MV-dca48e2b2a1e193a29a3adc1355ea5d9.svg";